import React, {FC} from "react";
import styled from "@emotion/styled";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {IKeyChangesController} from "./key_changes.controller";
import {ListItemLeft, ListItemRight} from "./list_item/list_item.component";

const Wrapper = styled.div`
	width: 100%;
	padding: 12px;
	display: flex;
	flex-direction: column;
	border-radius: 4px;
	background: ${({theme}) => theme.palette.statsModal.statsItemBg};
	box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.15);
	white-space: nowrap;
	font-size: 11px;
	font-weight: 500;
	line-height: 12px;
	gap: 12px;
	position: relative;
`;
// TODO remove commented code after QA passed
// // const Head = styled.div`
// 	width: 100%;
// 	display: flex;
// 	align-items: center;
// 	justify-content: space-between;
// `;

// const HeadText = styled.div`
// 	display: flex;
// 	align-items: center;
// 	gap: 1px;
// 	font-size: 10px;
// 	font-weight: 500;
// 	line-height: 8px;
// 	letter-spacing: 1.25px;
// 	text-transform: uppercase;

// 	svg {
// 		width: 12px;
// 		height: 12px;
// 	}
// `;

const List = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 2px;
`;

const ListWrapper = styled.div`
	margin-top: 6px;
	display: flex;
	flex: 2;
	flex-direction: row;
	align-items: center;
`;
// const Arrows = styled.div`
// 	display: flex;
// 	align-items: center;
// 	gap: 1px;
// 	border-radius: 4px;
// 	background:  ${({theme}) => theme.palette.leagues.primary};
// 	padding: 4px 6px;
// 	color: #fff;
// 	height: 20px;
// 	width: 37px;
// 	svg {
// 		width: 12px;
// 		height: 12px;
// 	}
// `;

const ArrowsIn = styled.div`
	display: flex;
	align-items: center;
	gap: 1px;
	border-radius: 4px;
	background: ${({theme}) => theme.palette.leagues.primary};
	justify-content: center;
	padding: 4px 6px;
	color: #fff;
	height: 20px;
	width: 37px;
	svg {
		width: 12px;
		height: 12px;
	}
`;
const ArrowsOut = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1px;
	border-radius: 4px;
	background: #d0011b;
	padding: 4px 6px;
	color: #fff;
	height: 20px;
	width: 37px;
	svg {
		width: 12px;
		height: 12px;
	}
`;
interface IKeyChanges {
	tournamentId: number;
}

export const KeyChanges: FC<IKeyChanges> = observer(({tournamentId}) => {
	const {hasKeyChanges, inAndOuts} = useViewController<IKeyChangesController>(
		Bindings.KeyChangesController,
		{tournamentId}
	);

	if (!hasKeyChanges) {
		return null;
	}
	return (
		<Wrapper>
			<ListWrapper className="list-wrapper">
				<List className="listing-out">
					{inAndOuts.homeIns.map((player, i) => (
						<ListItemLeft key={i} {...player} />
					))}
				</List>
				<ArrowsIn>IN</ArrowsIn>
				<List className="listing-in">
					{inAndOuts.awayIns.map((player, i) => (
						<ListItemRight key={i} {...player} />
					))}
				</List>
			</ListWrapper>
			<ListWrapper className="list-wrapper">
				<List className="listing-out">
					{inAndOuts.homeOut.map((player, i) => (
						<ListItemLeft key={i} {...player} />
					))}
				</List>
				<ArrowsOut>OUT</ArrowsOut>
				<List className="listing-in">
					{inAndOuts.awayOut.map((player, i) => (
						<ListItemRight key={i} {...player} />
					))}
				</List>
			</ListWrapper>
		</Wrapper>
	);
});
